import { useTranslation } from "@sagot/i18n";
import { Icon, Sheet, SheetContent } from "@sagot/ui";
import type { Definition } from "../types";
import { DryRunPanel } from "./dry-run-panel";
import { FacingPreview } from "./facing-preview";

const P = "engage.workflows.builder.preview";

interface PreviewDrawerProps {
  workflowId: string;
  /** The definition as the builder shows it, unsaved edits included. */
  definition: Definition;
  /** Customer-facing workflows run as a test conversation; background ones are walked as a dry run. */
  facing: boolean;
  onClose: () => void;
}

/** Right-hand drawer of the builder: runs the draft, never the live version, and sends nothing outside. */
export function PreviewDrawer({ workflowId, definition, facing, onClose }: PreviewDrawerProps) {
  const { t } = useTranslation();
  return (
    <Sheet open onOpenChange={(open) => { if (!open) onClose(); }}>
      <SheetContent
        title={t(facing ? `${P}.title` : `${P}.dry.title`)}
        description={t(facing ? `${P}.description` : `${P}.dry.description`)}
        closeLabel={t("common.close")}
        className="max-w-md"
      >
        <div className="flex min-h-full flex-col gap-4">
          <p className="flex items-start gap-2 rounded-md bg-warning-soft p-3 text-xs font-semibold" data-testid="preview-banner">
            <Icon name="eye-off" className="mt-0.5 size-4 shrink-0" />
            {t(facing ? `${P}.banner` : `${P}.dry.banner`)}
          </p>
          {facing ? <FacingPreview workflowId={workflowId} definition={definition} /> : <DryRunPanel workflowId={workflowId} definition={definition} />}
        </div>
      </SheetContent>
    </Sheet>
  );
}
